<template>
  <div :class="d._class" :id="d._id">
    <div class="container">
      <h3>{{d._title}}</h3>
      <ul class="date">
        <!-- <li>
          Abstract submission deadline:
          <b>{{d.abstractSubmissionDeadline}}</b>
        </li> -->
        <li>
          Paper submission deadline:
          <b>{{d.paperSubmissionDealine}}</b>
        </li>
        <li>
          Notifications:
          <b>{{d.notification}}</b>
        </li>
        <li>
          Camera ready deadline:
          <b>{{d.cameraReadyDealine}}</b>
        </li>
        <li>
          Workshop day:
          <b>{{d.workshopDay}}</b>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BasicSection from "@/components/BasicSection";
export default {
  components: { BasicSection },
  name: "ImportantDates",
  props: {
    datum: {
      type: Object,
      default: function() {
        return {
          paragraphs: []
        };
      }
    }
  },
  data() {
    return {
      d: {
        _class: "team colored-bg",
        _title: "Important Dates",
        _id: "ImportantDates",
        ...this.datum
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li {
  font-size: 1.3em;
}
</style>



// WEBPACK FOOTER //
// src/components/ImportantDates.vue